import { eTipoPermissao } from '@/enums/ePermissoes';

export default [
  {
    path: '/transporte/trapassagemaluno',
    name: 'trapassagemaluno',
    description: 'Passagens por Estudante',
    component: () => import('@/views/transporte/trapassagemaluno/Index.vue'),
    meta: { permissions: [eTipoPermissao.PASSAGEMALUNONOVO_MENU_1100200899] },
    goesToMenu: true,
  },
];
